import * as types from "./personalDataActionTypes";
import api from "./personalDataApi";

export function clear(model) {
    return {
        type: types.CLEAR,
        model,
    };
}

export function get(model, query, headers) {
    return {
        type: types.AUTHENTICATE_MEMBER,
        model,
        promise: api.get(model, query, headers),
    };
}

export function getItem(model, query, headers) {
    return {
        type: types.HAS_PERSONAL_DATA_FORM,
        model,
        promise: api.getItem(model, query, headers),
    };
}

export function patch(model, body, headers) {
    return {
        type: types.PERSONAL_DATA_PATCH,
        model,
        promise: api.patch(model, body, headers),
    };
}



// WEBPACK FOOTER //
// ./src/components/personal-data/personalDataAction.js